import { styled } from '@mui/material/styles';
import { ICellRendererParams } from 'ag-grid-community';

// custom params to be used with cellRendererParams
export type EditablePercentageCellParams = ICellRendererParams & {
    rowGroupField: string;
    rowGroupTotalField?: string;
    aggregationLabel?: string;
};

export const RowGroupCell = (componentProps: EditablePercentageCellParams) => {
    const { valueFormatted, value, node, rowGroupField, aggregationLabel = 'Sum' } = componentProps;

    const isFooter = node?.data?.isFooter;

    if (node?.aggData && !node?.field) {
        return aggregationLabel;
    }

    if (valueFormatted === undefined) {
        return <div>{value}</div>;
    }

    if ((node.field === rowGroupField || valueFormatted === 'Stock Room') && !isFooter) {
        return <ProductLineCellWrapper>{valueFormatted}</ProductLineCellWrapper>;
    }

    if (isFooter) {
        return <div>{valueFormatted ?? value}</div>;
    }

    return <GenderCellWrapper>{valueFormatted}</GenderCellWrapper>;
};

const ProductLineCellWrapper = styled('div')`
  font-size: 16px;
  height: 22px;
  font-weight: bold;
`;

const GenderCellWrapper = styled('div')`
  padding-left: 10px;
`;
